var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.25,
    height: 19,
    viewBox: "0 0 14.25 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu_Icon_Documents",
    transform: "translate(-13.637 -1.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36184",
    "data-name": "Path 36184",
    d: "M27.59,3.891H26.7V3a.3.3,0,0,0-.3-.3h-.891v-.89a.3.3,0,0,0-.3-.3H13.934a.3.3,0,0,0-.3.3v16.03a.3.3,0,0,0,.3.3h.891v.891a.3.3,0,0,0,.3.3h.891v.891a.3.3,0,0,0,.3.3H27.591a.3.3,0,0,0,.3-.3V4.188a.3.3,0,0,0-.3-.3ZM14.231,2.11H24.919V17.547H14.231Zm1.187,16.03h9.8a.3.3,0,0,0,.3-.3V3.3h.594V18.734H15.418Zm11.874,1.781H16.606v-.594h9.8a.3.3,0,0,0,.3-.3V4.485h.594Z",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36185",
    "data-name": "Path 36185",
    d: "M19.992,12.324h3.563a.3.3,0,0,0,.3-.3V7.871a.3.3,0,0,0-.3-.3H19.992a.3.3,0,0,0-.3.3v4.156A.3.3,0,0,0,19.992,12.324Zm.3-4.156h2.969v3.563H20.289Z",
    transform: "translate(-4.871 -4.871)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36186",
    "data-name": "Path 36186",
    d: "M19.992,38.473H28.9a.3.3,0,1,0,0-.594H19.992a.3.3,0,0,0,0,.594Z",
    transform: "translate(-4.871 -29.238)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36187",
    "data-name": "Path 36187",
    d: "M19.992,47.563H28.9a.3.3,0,1,0,0-.594H19.992a.3.3,0,0,0,0,.594Z",
    transform: "translate(-4.871 -36.547)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36188",
    "data-name": "Path 36188",
    d: "M19.992,56.653H28.9a.3.3,0,1,0,0-.594H19.992a.3.3,0,1,0,0,.593Z",
    transform: "translate(-4.871 -43.856)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36189",
    "data-name": "Path 36189",
    d: "M44.234,20.29H48.39a.3.3,0,0,0,0-.594H44.234a.3.3,0,1,0,0,.594Z",
    transform: "translate(-24.363 -14.618)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36190",
    "data-name": "Path 36190",
    d: "M44.234,29.379H48.39a.3.3,0,0,0,0-.594H44.234a.3.3,0,1,0,0,.593Z",
    transform: "translate(-24.363 -21.926)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36191",
    "data-name": "Path 36191",
    d: "M19.992,65.747H28.9a.3.3,0,1,0,0-.594H19.992a.3.3,0,1,0,0,.594Z",
    transform: "translate(-4.871 -51.168)",
    fill: "#243746"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36192",
    "data-name": "Path 36192",
    d: "M28.9,74.836a.3.3,0,1,0,0-.594H19.992a.3.3,0,1,0,0,.594Z",
    transform: "translate(-4.871 -58.477)",
    fill: "#243746"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconDocuments);
export default __webpack_public_path__ + "static/media/Menu_Icon_Documents.c90aaa6d.svg";
export { ForwardRef as ReactComponent };